export default {
  LOAD_STUDY_PLAN_CYCLE_STUDENT_DEPARTMENTS_LIST_START: 'LoadStudyPlanCycleStudentDepartmentsListStart',
  LOAD_STUDY_PLAN_CYCLE_STUDENT_DEPARTMENTS_LIST_END: 'LoadStudyPlanCycleStudentDepartmentsListEnd',
  OPEN_STUDY_PLAN_CYCLE_STUDENT_DEPARTMENT_DELETE_CONFIRM_DIALOG: 'OpenStudyPlanCycleStudentDepartmentDeleteConfirmDialog',
  CLOSE_STUDY_PLAN_CYCLE_STUDENT_DEPARTMENT_DELETE_CONFIRM_DIALOG: 'CloseStudyPlanCycleStudentDepartmentDeleteConfirmDialog',
  DELETE_STUDY_PLAN_CYCLE_STUDENT_DEPARTMENT: 'DeleteStudyPlanCycleStudentDepartment',
  SUBMIT_STUDY_PLAN_CYCLE_STUDENT_DEPARTMENTS_DESIGNATION_START: 'LoadStudyPlanCycleStudentDepartmentDesignationStart',
  SUBMIT_STUDY_PLAN_CYCLE_STUDENT_DEPARTMENTS_DESIGNATION_END: 'LoadStudyPlanCycleStudentDepartmentsDesignationEnd'
};